import React from "react";
import { Redirect } from "react-router-dom";

import Balance from "../pages/balance/index"
import Indication from "../pages/indicators/home/index"
import MyCode from "../pages/my_code/Index"
import Flyer from "../pages/flyer/Index"
import Ong from "../pages/registers/ong/index"
import Passager from "pages/registers/passager/index";
import Provider from "pages/registers/provider/index";
import PoliciesList from "pages/policies/index";
import Policie from "pages/policies/detail/index";
import UniverseSigmobi from "pages/universe-sigmobi/Index"

const authProtectedRoutes = [

];

// Obs: Novos objectos de rotas devem ser adicionadas ao topo array
// rotas padronizada, não remover os comentários
const publicRoutes = [

  { path: "/", exact: true, component: UniverseSigmobi },

 /* { path: "/p",  exact: true,  component: PoliciesList},
  { path: "/term/:id",  exact: true,  component: Policie},

  { path: "/policies", exact: true, component: PoliciesList},
  { path: "/policie/:id", exact: true, component: Policie},

  { path: "/universe-sigmobi", exact: true, component: UniverseSigmobi },
  { path: "/invitation/:code?", exact: true, component: Indication },
  { path: "/register/ong/:code?", exact: true, component: Ong },
  { path: "/register/passager/:code?", exact: true, component: Passager },
  { path: "/register/provider/:code?", exact: true, component: Provider },
  { path: "/balance", exact: true, component: Balance },
  { path: "/my-code/:code?", exact: true, component: MyCode },
  { path: "/flyer/:code?/:generate?", exact: true, component: Flyer },

  { path: "/:code?/:generate?", exact: true, component: Flyer },
  { path: "/:code?", exact: true, component: Indication },
  { path: "/", exact: true, component: () => <Redirect to="/invitation" /> },
   */
];


export { authProtectedRoutes, publicRoutes };
